<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <EtablissementSection />
  <AdresseExecutionContratSection />
</template>

<script setup lang="ts">
  import EtablissementSection from './sections/etablissement/EtablissementSection.vue'
  import AdresseExecutionContratSection from './sections/adresseExecutionContrat/AdresseExecutionContratSection.vue'
</script>
